import { Directive } from '@angular/core';

@Directive({
  selector: '[portalPageHeadingPostfix]',
  standalone: false,
})
export class PageHeadingPostfixDirective {
  constructor() {}
}
